import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { SharedModule } from '../shared/shared.module';
import { CurrencyInputComponent } from './components/currency-input/currency-input.component';
import { CurrencyRateComponent } from './components/currency-rate/currency-rate.component';
import { DateInputComponent } from './components/date/date-input.component';
import { EInvoiceDateInputComponent } from './components/einvoice-date/einvoice-date-input.component';
import { EInvoiceTextInputComponent } from './components/einvoice-text-input/einvoice-text-input.component';
import { EInvoiceTINInputComponent } from './components/einvoice-tin-input/einvoice-tin-input.component';
import { EinvoiceTinSelectInputComponent } from './components/einvoice-tin-select-input/einvoice-tin-select-input.component';
import { MemoInputComponent } from './components/memo/memo.component';
import { MultiEmailInputComponent } from './components/multi-email-input/multi-email-input.component';
import { NumberOnlyInputComponent } from './components/number-only-input/number-only-input.component';
import { PercentInputComponent } from './components/percent/percent-input.component';
import { QtyInputComponent } from './components/qty-input/qty-input.component';
import { RegNoInputComponent } from './components/regno-input/regno-input.component';
import { TelInputComponent } from './components/tel/tel-input.component';
import { TextInputComponent } from './components/text/text.component';
import { TINBranchInputComponent } from './components/tin-branch-input/tin-branch-input.component';
import { TINInputComponent } from './components/tin-input/tin-input.component';
import { TINSignatoryInputComponent } from './components/tin-signatory-input/tin-signatory-input.component';
import { ZipcodeInputComponent } from './components/zipcode/zipcode-input.component';

// #region third libs

// #endregion

// #region your componets & directives

const COMPONENTS: Array<Type<void>> = [
  RegNoInputComponent,
  TINInputComponent,
  TINSignatoryInputComponent,
  TINBranchInputComponent,
  DateInputComponent,
  CurrencyInputComponent,
  CurrencyRateComponent,
  QtyInputComponent,
  TextInputComponent,
  MemoInputComponent,
  ZipcodeInputComponent,
  PercentInputComponent,
  TelInputComponent,
  EInvoiceDateInputComponent,
  EInvoiceTextInputComponent,
  EInvoiceTINInputComponent,
  EinvoiceTinSelectInputComponent,
  NumberOnlyInputComponent,
  MultiEmailInputComponent
];

const DIRECTIVES: Array<Type<void>> = [];
const PIPES: Array<Type<void>> = [];

const SERVICES: Array<Type<void>> = [];
// #endregion

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NzDatePickerComponent,
    NzAutocompleteModule,
    NzSelectModule,
    ReactiveFormsModule,
    FormsModule,
    NzIconModule
  ],
  providers: [...SERVICES],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES
  ],
  exports: [
    CommonModule,
    SharedModule,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES
  ]
})
export class InputModule { }
